interface ObjectWithMessage {
  message: string;
}
export function isObjectWithMessage(obj: unknown): obj is ObjectWithMessage {
  return obj !== null && typeof obj === 'object' && 'message' in obj;
}
